<template lang="html">
  <span class="">
    <span v-if="loading" class="loading text-center"><i class="far fa-pulse fa-spinner"></i></span>
    <span v-if="guarantorProps">{{ guarantorProps.name_first }} {{ guarantorProps.name_last }}</span>
  </span>
</template>

<script>
import Vue from 'vue'

export default {
  props: ['guarantorAccountId'],
  data () {
    return {
      loading: true,
      guarantorProps: null,
      guarantorUid: null,
    }
  },
  computed: {

  },
  mounted() {
    if(this.guarantorAccountId) {
      Vue.db.ref(`guarantor_accounts/${this.guarantorAccountId}/private/guarantor_uid`)
        .once('value')
        .then(uidSnap => {
          if(uidSnap.exists()) {
            this.guarantorUid = uidSnap.val();
            return Vue.db.ref(`/user_props/${this.guarantorUid}`)
              .once('value');
          }
          console.log("couldn't load guarantor account");
          return false;
        })
        .then(snapshot => {
          if(snapshot && snapshot.exists()) {
            this.guarantorProps = snapshot.val();
            this.loading = false;
            return true;
          }
          console.log("couldn't load guarantor props");
          return false;
        })
        .catch(err => console.log(err));
    } else {
      console.error("no data to load")
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";
</style>
